export interface BoardThemeResponse {
    Id: number;
    BackgroundImageId: string;
}

export class BoardTheme {
    id: number;
    backgroundImageId: string;

    constructor(fromServer: BoardThemeResponse = null) {
        if (fromServer != null) {
            this.id = fromServer.Id;
            this.backgroundImageId = fromServer.BackgroundImageId;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/BoardTheme.ts